export class DisplayTab {
  constructor (name, title, sequence, content, components) {
    this.Name = name
    this.Title = title
    this.Sequence = sequence
    this.Content = content
    this.Components = components
  }
}
